import(/* webpackMode: "eager" */ "/codebuild/output/src2380773144/src/node_modules/next/dist/client/image-component.js");
;
import(/* webpackMode: "eager" */ "/codebuild/output/src2380773144/src/src/app/ui/customercenter/onboarding-floating-container.css");
;
import(/* webpackMode: "eager" */ "/codebuild/output/src2380773144/src/src/images/cityMarkers/1.png");
;
import(/* webpackMode: "eager" */ "/codebuild/output/src2380773144/src/src/images/cityMarkers/2.png");
;
import(/* webpackMode: "eager" */ "/codebuild/output/src2380773144/src/src/images/cityMarkers/3.png");
;
import(/* webpackMode: "eager" */ "/codebuild/output/src2380773144/src/src/images/cityMarkers/4.png");
;
import(/* webpackMode: "eager" */ "/codebuild/output/src2380773144/src/src/images/cityMarkers/5.png");
;
import(/* webpackMode: "eager" */ "/codebuild/output/src2380773144/src/src/images/cityMarkers/6.png");
